// The calculators' own bundle, included by a free tool's page alone (see
// app/views/free_tools/tools/show.html.erb). Its own Stimulus application,
// so it needs nothing from application.js and adds no request to the pages
// that do not use it.
import { Application } from "@hotwired/stimulus"
import { register } from "./controllers/free_tools/index"

const application = Application.start()
register(application)
